import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { materialFieldDefaults } from '../shared/material-field-defaults';
import { MatNativeDateModule } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDividerModule } from '@angular/material/divider';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatFabButton } from '@angular/material/button';

@NgModule({
    declarations: [],
    imports: [
        MatTableModule,
        MatTabsModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatButtonModule,
        MatCardModule,
        MatSidenavModule,
        MatFormFieldModule,
        MatMenuModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatListModule,
        MatTooltipModule,
        MatNativeDateModule,
        MatGridListModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatProgressBarModule,
        MatDividerModule,
        MatBottomSheetModule,
        MatRadioModule,
        MatChipsModule,
        MatFabButton
    ],
    exports: [
        MatTableModule,
        MatTabsModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatButtonModule,
        MatCardModule,
        MatSidenavModule,
        MatFormFieldModule,
        MatMenuModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatListModule,
        MatTooltipModule,
        MatNativeDateModule,
        MatGridListModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatProgressBarModule,
        MatDialogModule,
        MatDividerModule,
        MatBottomSheetModule,
        MatSortModule,
        MatRadioModule,
        MatChipsModule,
        MatFabButton
    ],
    providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: materialFieldDefaults },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } }
    ]
})
export class MaterialModule {
}
